module.exports = __webpack_public_path__ + "img/l3.3686c54c.png";